import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";

const Upload = () => {
  const navigate = useNavigate();
  const [selectedImages, setSelectedImages] = useState([]);
  const fileInputRef = useRef(null);

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleChange = (e) => {
    const files = e.target.files;
    const filesArray = Array.from(files);
    setSelectedImages([...selectedImages, ...filesArray]);
    navigate("/scan-floor", { state: { selectedImages: filesArray } });
  };

  return (
    <div className="upload">
      <div className="content" onClick={handleClick}>
        <img src="/assets/icons/upload-blueprint.svg" alt="" />
        <h3> Upload Floorplan</h3>
      </div>
      {/* Hidden file input */}
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        multiple
        style={{ display: "none" }}
        onChange={handleChange}
      />
    </div>
  );
};

export default Upload;
